/**
 * UI8 Author Shaders
 * Pulsing WebGL shader borders for the featured author card and avatar.
 * Depends on window.PaperShadersUtils (paper-shaders-utils.js).
 * Usage: initAuthorCardBorder(el); initAuthorAvatarBorder(el);
 */

var AUTHOR_COLORS = ['#2d68ff', '#a855f7', '#ff3a1a', '#3570ff'];

function initAuthorCardBorder(el) {
  window.PaperShadersUtils.mountPulsingBorder(el, {
    u_colors: AUTHOR_COLORS,
    u_colorsCount: 4,
    u_roundness: 0.27,
    u_thickness: 0.4,
    u_softness: 1.8,
    u_intensity: 1.25,
    u_bloom: 0.25,
    u_spots: 4,
    u_spotSize: 0.5,
    u_pulse: 0,
    u_smoke: 0.1,
    u_smokeSize: 0.05,
  });
}

function initAuthorAvatarBorder(el) {
  window.PaperShadersUtils.mountPulsingBorder(el, {
    u_colors: AUTHOR_COLORS,
    u_colorsCount: 4,
    u_roundness: 1.0,
    u_thickness: 0.01,
    u_softness: 2.0,
    u_intensity: 0.2,
    u_bloom: 0.4,
    u_spots: 4,
    u_spotSize: 0.56,
    u_pulse: 0.15,
    u_smoke: 0.3,
    u_smokeSize: 0.0,
  });
}

window.AuthorShaders = { initAuthorCardBorder: initAuthorCardBorder, initAuthorAvatarBorder: initAuthorAvatarBorder };
